<a nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu">
  @if ( selectedLocale.flag | country : { select: ['emoji'] } | async; as
  country ) {
  <span>{{ country.emoji }}</span>
  }
  {{ selectedLocale.name }}
  <un-icon class="t-small" type="right" theme="outline"></un-icon>
</a>
<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    @for (locale of _locales; track locale) {
    <li nz-menu-item (click)="select(locale)">
      <a [href]="locale.link" target="_self">
        @if ( locale.flag | country : { select: ['emoji'] } | async; as country
        ) {
        <span>{{ country.emoji }}</span>
        }
        {{ locale.name }}</a
      >
    </li>
    }
  </ul>
</nz-dropdown-menu>
